export const AI_JOB_STATUSES = {
  QUEUED: 'queued',
  CREATING: 'creating',
  RUNNING: 'running',
  PENDING_OUTPUT: 'pending_output',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
} as const;

export type AiJobStatus =
  (typeof AI_JOB_STATUSES)[keyof typeof AI_JOB_STATUSES];

export const AI_JOB_TERMINAL_STATUSES = [
  AI_JOB_STATUSES.SUCCEEDED,
  AI_JOB_STATUSES.FAILED,
] as const;

export type AiJobTerminalStatus = (typeof AI_JOB_TERMINAL_STATUSES)[number];

export function isAiJobTerminalStatus(
  status: string
): status is AiJobTerminalStatus {
  return (
    status === AI_JOB_STATUSES.SUCCEEDED || status === AI_JOB_STATUSES.FAILED
  );
}

export function isAiJobStatus(status: string): status is AiJobStatus {
  return Object.values(AI_JOB_STATUSES).includes(status as AiJobStatus);
}
